import {
  ProgramUser,
  OidcConfig,
  SessionAuthResponse,
  AuthFormInputs,
  LogoutRequest,
} from 'features/auth/types';
import { WellframeApi } from 'store/api';

export const authService = WellframeApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<SessionAuthResponse, AuthFormInputs>({
      query: (credentials) => ({
        url: '/mobileapi/v1/members/login',
        method: 'POST',
        body: credentials,
      }),
    }),
    resetPassword: builder.mutation({
      query: ({ email }) => ({
        url: `/mobileapi/v1/members/password-reset?email=${email}`,
        method: 'POST',
      }),
    }),
    getUser: builder.query<ProgramUser, void>({
      query: () => '/api/v5/me',
    }),
    validateEmail: builder.query<OidcConfig, { email: string }>({
      query: ({ email }) => ({
        url: `/mobileapi/v1/auth/config/user?email=${email}`,
      }),
    }),
    logout: builder.mutation<void, LogoutRequest>({
      query: (data) => ({
        url: '/mobileapi/v1/members/logout',
        method: 'POST',
        body: { refreshToken: data.refreshToken, global: false },
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useResetPasswordMutation,
  useLazyGetUserQuery,
  useLazyValidateEmailQuery,
  useLogoutMutation,
} = authService;
